import React from "react";

import ContactUs from "../../Components/Utilities/ContactUs"

const ContactusPage = () => {
  return (
    <div>
    <ContactUs/>
    </div>

  );
};

export default ContactusPage;
